/**
 * Default Preparo templates for new book projects.
 * These provide a starting structure for titlepage and copyright page.
 */

export const DEFAULT_TITLEPAGE = `# Page de titre {epub:type=titlepage .titlepage .page-end}
::: {.author}
Nom de l'auteur
:::

::: {.title}
Titre du livre
:::

::: {.subtitle}
Sous-titre
:::

::: {.publisher}
Maison d'édition
:::

::: {.place}
Lieu de publication
:::
`;

export const DEFAULT_COPYRIGHT = `# Copyright {epub:type=copyright-page .copyright-page .page-end}
::: {.edition}
Titre original : *Original Title*\\

\\
Édition originale publiée par Publisher, année.
:::

::: {.identifiers}
ISBN 000-0-000000-00-0
:::
`;

export interface DefaultPreparoTemplate {
  filename: string;
  content: string;
  description: string;
}

export const DEFAULT_PREPARO_TEMPLATES: DefaultPreparoTemplate[] = [
  {
    filename: 'titlepage.md',
    content: DEFAULT_TITLEPAGE,
    description: 'Page de titre par défaut',
  },
  {
    filename: 'copyright-page.md',
    content: DEFAULT_COPYRIGHT,
    description: 'Page de copyright par défaut',
  },
];
